export default __webpack_public_path__ + "static/media/usdt_tron.d8e7dab2.svg";